import { OutletGroups } from 'app/interfaces';

// Keep outlet-group choices consistent wherever search filters are offered.
export function selectableOutletGroups(groups: OutletGroups[], isAdmin: boolean): OutletGroups[] {
  return (groups || []).filter(group => (!group.internal && !group.noFilter) || isAdmin);
}
